// extracted by mini-css-extract-plugin
export var pageHeader = "main-module--pageHeader--2mZXp";
export var pageMain = "main-module--pageMain--WC5gk";